import { render, staticRenderFns } from "./DialogConfirmation.vue?vue&type=template&id=ba9fee1c"
import script from "./DialogConfirmation.vue?vue&type=script&lang=js"
export * from "./DialogConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports